import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import {Table, Column, AutoSizer} from 'react-virtualized';
import Tooltip from 'react-tooltip';
import debounce from 'lodash/debounce';
import { withStyles } from '@material-ui/core/styles';
import Footer from '../../Components/Footer';
import RenderNameHeader from '../../Components/Table/RenderNameHeader';
import RenderName from '../../Components/Table/RenderName';
import RenderRankHeader from '../../Components/Table/RenderRankHeader';
import RenderRank from '../../Components/Table/RenderRank';
import RenderEventHeader from '../../Components/Table/RenderEventHeader';
import RenderEvent from '../../Components/Table/RenderEvent';
import Modal from '../../Components/Table/Modal';
import Divisions from '../../Components/Divisions';

import './Table.css';
import 'react-virtualized/styles.css';

const styles = theme => ({
  rowStyles: {
    borderBottom: '1px solid #e5e5e5',
    borderLeft: '1px solid #e5e5e5',
    borderRight: '1px solid #e5e5e5'
  },
  headerStyles: {
    borderTop: '1px solid #e5e5e5'
  }
});

const rebuildTooltip = debounce(() => Tooltip.rebuild(), 200, {
  leading: false,
  trailing: true
})

class TableWrap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIdx: 1,
      howManyToShow: 3,
      maxIdx: 0,
      fixed: false,
      modalOpen: false,
      selectedMember: {},
      nameWidth: 0,
      rankWidth: 0,
      activeSort: -1
    }

    this.increaseIdx = this.increaseIdx.bind(this);
    this.decreaseIdx = this.decreaseIdx.bind(this);
    this.updateSort = this.updateSort.bind(this);
    this.resizeFunc = this.resizeFunc.bind(this);
    this.handleWidthResize = this.handleWidthResize.bind(this);
    this.selectIdx = this.selectIdx.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(selectedMember) {
    this.setState({
      modalOpen: true,
      selectedMember: selectedMember
    });
  }

  closeModal() {
    this.setState({
      modalOpen: false
    });
  }

  updateSort(sortVal) {
    if(this.props.loading) return true;
    this.props.getPage(undefined, undefined, false);
    this.setState({
      activeSort: sortVal
    });
  }

  componentDidMount() {
    rebuildTooltip();

    window.addEventListener('scroll', (e) => {

      let yPosition = 0;
      let topOfTable = document.getElementsByClassName('table')[0];

      if(!topOfTable) return;

      let location = 0;
      if (topOfTable.offsetParent) {
        do {
          location += topOfTable.offsetTop;
          topOfTable = topOfTable.offsetParent;
        } while (topOfTable);
      }
      yPosition = location >= 0 ? location : 0;

      const scrollpos = window.scrollY;

      if(scrollpos > yPosition && !this.state.fixed) {
        return this.setState({
          fixed: true
        })
      } else if(scrollpos < yPosition && this.state.fixed) {
        return this.setState({
          fixed: false
        })
      }
    })
  }

  stepperHelper(stopHeight) {
    let start = null;
    let body = document.body;
    let html = document.documentElement;
    if(!stopHeight) return;

    const step = (timestamp) => {
      let height = Math.max( body.scrollHeight, body.offsetHeight, 
                       html.clientHeight, html.scrollHeight, html.offsetHeight );      
      if(!start) start = timestamp;
      let progress = timestamp - start;
      window.scrollTo(0, Math.min(progress * 5));
      
      // if we hit stopheight or hit bottom of screen
      if((window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop) < stopHeight &&
      (window.pageYOffset ? window.pageYOffset : document.documentElement.scrollTop) + window.innerHeight < height) {
        window.requestAnimationFrame(step);
      } else {
        setTimeout(() => {
          let element = document.getElementById('string-selected');

          if(element) {
            element.id = '';
          }
        }, 800);

        return;
      }
    }

    return window.requestAnimationFrame(step);
  }

  // NOT LIVE MAX IDX
  componentWillReceiveProps(nextprops) {
    // if we don't have any event_ids but are about to get them
    if(!this.props.data[0] && nextprops.data[0]) {
      if(nextprops.data[0].scores) return this.setState({maxIdx: nextprops.data[0].scores.length + 2});
    // if our event ids are coming through, and do not match
    } else if(this.props.eventConfig.event_ids && nextprops.eventConfig.event_ids) {
      if(this.props.eventConfig.event_ids.length !== nextprops.eventConfig.event_ids.length) {
        return this.setState({
          maxIdx: nextprops.eventConfig.event_ids.length + 2
        })
      }
    }
  }

  componentDidUpdate(prevProps) {

    if(prevProps.scrollTo !== this.props.scrollTo && this.props.scrollTo) {
      let array = document.getElementsByClassName('ReactVirtualized__Table__row');
      let element = array[this.props.scrollTo - 1];
      let yscroll = 0;

      if(!element) return;

      yscroll += (element.offsetTop - element.scrollTop + element.clientTop); 
      element.id = 'string-selected';

      let yPosition = 0;
      let topOfTable = document.getElementsByClassName('table-wrap')[0];

      if(!topOfTable) return;

      let location = 0;
      if (topOfTable.offsetParent) {
        do {
          location += topOfTable.offsetTop;
          topOfTable = topOfTable.offsetParent;
        } while (topOfTable);
      }
      yPosition = location >= 0 ? location : 0;
      
      window.scrollTo(0, (yscroll + yPosition) - ((window.innerHeight) / 2) )

      setTimeout(() => {
        let element = document.getElementById('string-selected');

        if(element) {
          element.id = '';
        }
      }, 1200);

    }
  }

  // We want to: Show a width determined amount of columns, starting at a specified index
  increaseIdx() {
    let currIdx = this.state.activeIdx;

    if(currIdx >= this.state.maxIdx - this.state.howManyToShow) return;
    this.setState({
      activeIdx: currIdx + 1
    }, () => {
      rebuildTooltip();
    })
  }

  decreaseIdx() {
    let currIdx = this.state.activeIdx;
    if(currIdx <= 1) return;
    this.setState({
      activeIdx: currIdx - 1
    }, () => {
      rebuildTooltip();
    })
  }

  selectIdx(idx) {
    let currIdx = this.state.activeIdx;
    if(currIdx === idx) return;

    this.setState({
      activeIdx: idx
    }, () => {
      rebuildTooltip();
    })
  }

  resizeFunc({height, width}) {
    rebuildTooltip();
    
    if(width > 1050 && this.state.howManyToShow !== 4) {
      this.setState({howManyToShow: 4})
    } else if(width <= 1050 && width > 900 && this.state.howManyToShow !== 3) {
      this.setState({howManyToShow: 3})
    } else if(width <= 900 && width > 768 && this.state.howManyToShow !== 2) {
      this.setState({howManyToShow: 2})
    } else if(width <= 768 && this.state.howManyToShow !== 1) {
      return this.setState({howManyToShow: 1})
    }
    this.handleWidthResize(width);
  }

  handleWidthResize(width) {
    let namewidth = this.state.nameWidth;
    if(width > 1050 && namewidth !== 600) return this.setState({nameWidth: 600, rankWidth: 200});// width /8;
    if(width > 900 && namewidth !== 450) return this.setState({nameWidth: 450, rankWidth: 150});// width / 7;
    if(width > 768 && namewidth !== 300) return this.setState({nameWidth: 300, rankWidth: 100});// width / 6;
    if(width <= 768) return this.setState({nameWidth: width / 1.5, rankWidth: width / 3});

  }


  render() {
    let divider = 9;
    if(this.state.howManyToShow === 2) {
      divider = 6;
    } else if(this.state.howManyToShow === 1) {
      divider = 3;
    }

    let parsedDataString = this.props.data[0] ? this.props.data[0].scores : [];

    return(<>
        <div>
          <Divisions
            leaderboardId={this.props.leaderboardId}
            divisionId={this.props.divisionId}
            switchLeaderboards={this.props.switchLeaderboards}
            reverse={this.props.reverse}
            eventId={this.props.activeEventId}
            fixed={this.state.fixed}
            activeIdx={this.state.activeIdx}
            eventConfig={this.props.eventConfig}
            howManyToShow={this.state.howManyToShow}
            updatedAt={this.props.updatedAt}
          />
        </div>
      <div className={'table-wrap'}>
        <div className={'table sorted-' + this.props.activeEventId + this.props.currentPageNumber + this.props.reverse + ' ' + (this.props.divisionId === process.env.REACT_APP_DIVISION_SECONDARY ? 'female' : '') + ' ' + (this.state.fixed ? ' fixed' : '')}>
          <AutoSizer 
            disableHeight
            onResize={this.resizeFunc}>
            {({width}) => (
              <Table 
                height={this.props.data.length > 0 ? (this.props.data.length + 2.5) * 60 : 0}
                rowGetter={(idx) => {
                  return(this.props.data[idx.index])
                }}
                headerHeight={140}
                rowHeight={60}
                rowCount={this.props.data.length}
                width={width}
                rowClassName={this.props.classes.rowStyles}
                columnWidth={10}
                scrollToIndex={this.props.scrollTo ? this.props.scrollTo : 0}>
                <Column
                  dataKey={'FullName'}
                  width={this.state.nameWidth}
                  label={'Athlete'}
                  flexGrow={this.state.howManyToShow === 1 ? 1 : 0}
                  headerRenderer={(headerArgs) => 
                    <RenderNameHeader 
                      headerArgs={headerArgs} 
                      activeSort={this.state.activeSort}
                      updateSort={this.updateSort}
                      hotVal={'Country'}
                      // getLeaderboard={this.props.getLeaderboard}
                      reverse={this.props.reverse}
                    />
                  }
                  cellDataGetter={({rowData}) => ({FullName: rowData.member_name, PlaceRank: rowData.rank, Nationality: rowData.Nationality, ImageUrl: rowData.member_image}) }
                  cellRenderer={(args) => 
                    <RenderName 
                      args={args}
                      openModal={this.openModal} 
                    />
                  }
                />
                {(this.state.activeIdx === 1) &&
                  <Column
                    dataKey="rank"
                    width={this.state.rankWidth}
                    flexGrow={this.state.howManyToShow === 1 ? 0.59 : 0}
                    label="Total Points"
                    cellDataGetter={({rowData}) => ({rank: rowData.rank, points: rowData.total_score})}
                    headerRenderer={(args) => 
                      <RenderRankHeader 
                        args={args} 
                        activeSort={this.props.activeEventId}
                        updateSort={this.updateSort}
                        // getPage={this.props.getPage}
                        // getLeaderboard={this.props.getLeaderboard}
                        reverse={this.props.reverse}
                      />
                    }
                    cellRenderer={(args) => 
                      <RenderRank args={args} />
                    }
                  />

                }
                {(parsedDataString || []).map((event, idx) => 
                  (this.state.activeIdx + this.state.howManyToShow > idx + 2 && !(this.state.activeIdx > idx + 2)) &&

                  <Column
                    key={idx}
                    dataKey={'scores'}
                    width={width / divider}
                    label={(idx + 1)}
                    flexGrow={this.state.howManyToShow === 1 ? 0 : 3}
                    headerRenderer={(tableArgs) =>
                      <RenderEventHeader 
                        tableArgs={tableArgs}
                        activeSort={this.props.activeEventId}
                        eventId={idx}
                        eventObject={event}
                      />
                    }
                    cellRenderer={(args) => 
                      <RenderEvent 
                        args={args}
                        workoutIdx={idx + 1} 
                      />
                    }
                  />
                )}
                
              </Table>
            )}
          </AutoSizer>
        </div>
        {(this.props.data.length <= 0 && !this.props.loading) &&
          <h1 className="mb5">NO RESULTS AVAILABLE</h1>
        }
        <Tooltip 
          type="dark" 
          effect="solid"
          place="left"
        />
        {/*<Dialog 
          onClose={this.closeModal}
          open={this.state.modalOpen}
          aria-labelledby="simple-dialog-title"
          scroll="body"
          >
          <Modal
            selectedMember={this.state.selectedMember}
            eventConfig={this.props.eventConfig}
            closeModal={this.closeModal}
          />
        </Dialog>*/}
        <Footer
          increaseIdx={this.increaseIdx}
          decreaseIdx={this.decreaseIdx}
          activeIdx={this.state.activeIdx}
          howManyToShow={this.state.howManyToShow}
          maxIdx={this.state.maxIdx}
          currentPageNumber={this.props.currentPageNumber}
          updatePage={this.props.getPage}
          lastPageNumber={this.props.lastPageNumber}
          selectIdx={this.selectIdx}
          // getLeaderboard={this.getLeaderboardFooterHack}
        />
      </div>
    </>)
  }
}

TableWrap.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  // updatePage: PropTypes.func.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  leaderboardId: PropTypes.number.isRequired,
  lastPageNumber: PropTypes.number,
  scrollTo: PropTypes.number,
  eventConfig: PropTypes.object.isRequired,
  activeEventId: PropTypes.number,
  reverse: PropTypes.bool.isRequired,
  divisionId: PropTypes.string.isRequired,
  switchLeaderboards: PropTypes.func.isRequired,
}

export default withStyles(styles)(TableWrap);
